import styled from 'styled-components';
import { Dropdown } from 'semantic-ui-react';
import { InputField } from '@cashfree-intl/coherent';

export const StyledItem = styled(Dropdown.Item)``;
export const StyledMenu = styled(Dropdown.Menu)``;
export const StyledSearchInput = styled(Dropdown.SearchInput)``;

export const StyledDropdownWithSearchOption: any = styled(Dropdown)`
  &.ui.dropdown {
    .menu {
      max-width: 300px;
      min-width: 250px;
      right: 0;
      left: auto !important;

      @media (max-width: 360px) {
        max-width: 90vw;
        min-width: auto;
      }
    }
    cursor: pointer;
    &.search {
      caret-color: transparent;
      user-select: none;
    }

    & > .dropdown.icon {
      display: none !important;
    }

    &.active {
      > i.icon {
        transform: rotate(180deg);
        position: relative;
        top: 8px;
      }
    }

    & > .visible.menu.transition {
      margin-top: 8px;
      border-radius: 6px;
      background-color: ${props => props.theme.COLORS.white};
      border: none;
      min-width: 300px;
      max-width: 300px;
      padding-top: 12px;
      padding-bottom: 10px;
      max-height: none;

      & .divider {
        margin-left: 24px;
        margin-right: 16px;
      }

      & .options-container {
        overflow-y: auto;
        max-height: 240px;
        margin-bottom: 2px;

        & .item {
          cursor: pointer;
          text-wrap: wrap;
          padding-left: 24px;
          padding-right: 16px;

          &.selected {
            background: ${props => props.theme.COLORS.selected};
          }

          &:hover {
            background: ${props => props.theme.COLORS.selected};
          }

          &:last-child {
            margin-bottom: 2px;
          }
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
`;

export const StyledInputField = styled(InputField)`
  padding-bottom: 4px;
  caret-color: auto;
`;

export const TimeZone = styled.button`
  background: transparent;
  border: none;
  padding: 0.25rem;
  border-radius: 100%;
  cursor: pointer;
  position: relative;
  &:hover {
    background: rgba(206, 177, 255, 0.3);
  }
`;
